import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { modalActions } from '../../redux/root-action';
import styled from 'styled-components';
import { keyDown } from '../../utils/helpers';

const StyledFooter = styled.div<{ customStyles: string }>`
  &&& {
    ${props => props.customStyles}
  }
  height: 104px;
  border-radius: 4px;
  box-shadow: inset 0 1px 0 0 #d7dbde;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 48px 0px 48px;
  background-color: rgba(0, 104, 148, 0.04);
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
    padding: 16px 16px 16px 16px;
    box-shadow: none;
    height: auto;
  }
`;

interface Props {
  CTAButtonText: string;
  buttonType?: string;
  handleCTAClick: () => void;
  handleCancelClick?: () => void;
  children?: any;
  hideCancel?: boolean;
  customStyles?: string;
  disabled?: boolean;
}

class ReactModalFooter extends React.Component<any, any> {
  divElement: HTMLDivElement | null = null;

  componentDidMount() {
    const { setModalFooterHeight } = this.props;
    const footerHeight = this.divElement ? this.divElement.clientHeight : 0;
    setModalFooterHeight(footerHeight);
  }

  render(): any {
    const {
      handleCTAClick,
      hideModal,
      buttonType,
      CTAButtonText,
      handleCancelClick,
      children,
      hideCancel = false,
      customStyles,
      disabled,
      CTAButtonId,
      CancelButtonId,
    } = this.props;
    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <StyledFooter
        id={`modal-footer`}
        customStyles={customStyles}
        ref={(element: HTMLDivElement) => {
          this.divElement = element;
        }}
      >
        {' '}
        {!mq.matches && !hideCancel && (
          <Button
            tabIndex={0}
            type="textButton"
            title="Cancel"
            onClick={handleCancelClick ? handleCancelClick : hideModal}
            style={{ marginRight: 16 }}
            id={CancelButtonId}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
              keyDown(e, handleCancelClick ? handleCancelClick : hideModal)
            }
          />
        )}
        {!mq.matches && children}
        {CTAButtonText && (
          <Button
            tabIndex={0}
            type={buttonType ? buttonType : 'primary'}
            title={CTAButtonText}
            onClick={handleCTAClick}
            fitContainerWidth={mq.matches ? true : false}
            disabled={disabled}
            id={CTAButtonId}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, handleCTAClick)}
          />
        )}
        {mq.matches && children}
      </StyledFooter>
    );
  }
}

export default connect(null, {
  hideModal: modalActions.hideModal,
  setModalFooterHeight: modalActions.setModalFooterHeight,
})(ReactModalFooter);
